import { render, staticRenderFns } from "./ListNotifications.vue?vue&type=template&id=75e5ba2b&scoped=true&"
import script from "./ListNotifications.vue?vue&type=script&lang=js&"
export * from "./ListNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ListNotifications.vue?vue&type=style&index=0&id=75e5ba2b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e5ba2b",
  null
  
)

export default component.exports